// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import VueI18n from 'vue-i18n'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader

import en from '../locale/en.ts'
import zh from '../locale/zh-Hans.ts'
import fr from '../locale/fr.ts'

Vue.use(Vuetify)
Vue.use(VueI18n)

// If a selected language could not be found in cached state,
// Select a default by using the users browser settings of understood language
let defaultLang = localStorage.getItem('lang')
if (!defaultLang) {
  if (navigator.language.includes('zh'))
    defaultLang = 'zh'
  if (navigator.language.includes("fr")) 
    defaultLang = "fr";
  else defaultLang = "en";
}

const getStoredPrimaryColor = () => {
  try {
    return localStorage.getItem('storePrimary') || '#1e9d84'
  } catch (error) {
    return '#1e9d84'
  }
}

const defaultTheme = {
  primary: getStoredPrimaryColor(),
  secondary: '#E97283',
  accent: '#77CEC9',
  error: '#e63d2c',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107'
}

Vue.use(Vuetify, {
  options: {
    customProperties: true
  },
  theme: {
    themes: {
      light: defaultTheme,
      dark: defaultTheme
    },
  },
  iconfont: 'mdi'
})

// Create VueI18n instance with options
window.i18n = new VueI18n({
  locale: defaultLang,
  messages: { en, zh, fr }
})

export default new Vuetify({
  lang: {
    t: (key, ...params) => window.i18n.t(key, params),
    current: defaultLang
  },
  theme: {
    themes: {
      light: defaultTheme,
      dark: defaultTheme
    },
  },
  icons: {
    iconfont: 'md',
  }
})
